import React, { useContext, useEffect, useMemo } from "react";
import { Container, Spinner } from "react-bootstrap";
import MainHeader from "../Layout/Header";
// import DisconnectedWallet from '../../components/DisconnectedWallet';
// import Footer from "../../components/CustomFooter";
import { AppContext } from "../../scripts/context";
import BalanceDetails from "./BalanceDetails/components";
import Footer from "../Layout/Footer";
import ComingSoonPage from "../presale/ComingSoon/components";
import LoadPage from "../presale/Live/components/LoadPage";

function Index() {
  const {
    state: {
      contracts: {
        presale: {
          data: { time },
        },
      },
      user,
    } = {},
  } = useContext(AppContext) || {};

  useEffect(() => {
    // Add class to body when component mounts
    document.body.classList.add("Visting");

    // Remove class from body when component unmounts
    return () => {
      document.body.classList.remove("Visting");
    };
  }, []); // Empty dependency array ensures this effect runs only once (on mount)

  const ComponentToRender = useMemo(() => {
    if (!user?.address) {
    return (
      <div className='h-screen w-screen d-flex align-items-center'>
        <Spinner animation='border' role='status' className='mx-auto' />
      </div>
    );
    }

    // if (time !== "after") {
    //   return <ComingSoonPage />;
    // }
    return <BalanceDetails />;
  }, [user]);

  return (
    <Container fluid>
      <MainHeader />
      {ComponentToRender}
      <Footer />
    </Container>
  );
}

export default Index;
